export { default } from './HeadingProduct';